import { Modal } from '@design-system/components/modal/modal';
import { Typography } from '@design-system/components/typography/typography';
import { CopyCard } from '@design-system/components/modals/CopyLinkModal';
import { afterDescStyles } from './linksModal.css';

export const LinksModal = ({
  isOpen,
  onClose,
  data,
}: {
  isOpen: boolean;
  onClose: () => void;
  data?: {
    programName?: string;
    afterDesc?: React.ReactNode;
    links: Array<{
      title: string;
      url: string;
      description: string;
      onEdit?: () => void;
    }>;
  };
}) => {
  if (!isOpen || !data) return null;
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title="Sharing links?"
      disableBackdropClick={true}
      modalClassName="w-full md:w-[742px]"
    >
      <div className="flex flex-col gap-6">
        {data.programName ? <Typography>{data.programName}:</Typography> : null}
        <div className="flex flex-col gap-4">
          {data.links.map((link) => (
            <CopyCard
              url={link.url}
              linkTitle={link.title}
              onEdit={link.onEdit}
              key={link.url}
            >
              <Typography variant="body" size="medium" fontWeight="normal">
                {link.description}
              </Typography>
            </CopyCard>
          ))}
        </div>
        {data.afterDesc ? (
          <div className={afterDescStyles}>
            <Typography variant="body" size="medium" fontWeight="normal">
              {data.afterDesc}
            </Typography>
          </div>
        ) : null}
      </div>
    </Modal>
  );
};
